import { signalableFactory } from './zendesk-comments.adapter';

export class GetCommentsForRequestSignal extends signalableFactory.create<
  'Get Comments For Request Signal',
  { requestId: number }
>('Get Comments For Request Signal') {}
